<template>
    <div>
        <el-carousel height="2.9rem" :autoplay="true" :interval="5000">
            <el-carousel-item>
                <img src="../../assets/images/banner/product/zhgd/1.jpg" width="100%" height="100%">
            </el-carousel-item>
            <el-carousel-item>
                <img src="../../assets/images/banner/product/zhgd/2.jpg" width="100%" height="100%">
            </el-carousel-item>
            <el-carousel-item>
                <img src="../../assets/images/banner/product/zhgd/3.jpg" width="100%" height="100%">
            </el-carousel-item>
        </el-carousel>
        <div class="content">
            <div class="lef">
                <div>智慧工地产品</div>
                <p v-for="(item,index) in btnList" :key="item.id">
                    <a :class="{'don':selectedIndex === index}" @click="changeSelected(item,index)">· {{
                            item.name
                        }}</a>
                </p>
            </div>
            <div class="right">
                <component :is="selectedPage"></component>
                <div class="but">
                    <span class="l" @click="upClick()">上一篇</span>
                    <span class="r" @click="nextClick()">下一篇</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TowerCrane from "./product-site-page/TowerCrane";
import Lift from "./product-site-page/lift";
import diaogou from "@/components/product/product-site-page/diaogou";
import longmendiao from "@/components/product/product-site-page/longmendiao";
import labor from "@/components/product/product-site-page/labor";
import anquanmao from "@/components/product/product-site-page/anquanmao";
import ele from "@/components/product/product-site-page/ele";
import penlin from "@/components/product/product-site-page/penlin";
import wifi from "@/components/product/product-site-page/wifi";
import jikeng from "@/components/product/product-site-page/jikeng";
import car from "@/components/product/product-site-page/car";
import ai from "@/components/product/product-site-page/ai";
import gongdi from "@/components/product/product-site-page/gongdi";
import dibang from "@/components/product/product-site-page/dibang";
import suidao from "@/components/product/product-site-page/suidao";

export default {
    components: {
        TowerCrane,
        Lift,
        diaogou,
        longmendiao,
        labor,
        anquanmao,
        ele,
        penlin,
        wifi,
        jikeng,
        car,
        ai,
        gongdi,
        dibang,
        suidao
    },
    data() {
        return {
            activeIndex: '1',
            btnList: [
                {name: '塔吊安全监控系统', page: 'tower-crane', img: require('./img/site/1.jpg')},
                {name: '塔吊吊钩可视化系统', page: 'diaogou', img: require('./img/site/2.jpg')},
                {name: '施工升降机安全监控系统', page: 'lift', img: require('./img/site/3.jpg')},
                {name: '龙门吊监控监测系统', page: 'longmendiao', img: require('./img/site/2.jpg')},
                {name: '劳务实名制管理系统', page: 'labor', img: require('./img/site/5.jpg')},
                {name: '智能安全帽', page: 'anquanmao', img: require('./img/site/6.jpg')},
                {name: '用电安全监测系统', page: 'ele', img: require('./img/site/7.jpg')},
                {name: '喷淋智能管理系统', page: 'penlin', img: require('./img/site/8.jpg')},
                {name: 'WIFI覆盖安全答题系统', page: 'wifi', img: require('./img/site/9.jpg')},
                {name: '基坑监测系统', page: 'jikeng', img: require('./img/site/10.jpg')},
                {name: '车辆管理系统', page: 'car', img: require('./img/site/11.jpg')},
                {name: 'AI隐患识别系统', page: 'ai', img: require('./img/site/12.jpg')},
                {name: '工地广播提醒协防系统', page: 'gongdi', img: require('./img/site/13.jpg')},
                {name: '智能地磅管理系统', page: 'dibang', img: require('./img/site/14.png')},
                {name: '隧道人员定位系统', page: 'suidao', img: require('./img/site/15.png')},
            ],
            selectedIndex: 0,
            selectedPage: 'tower-crane',
        }
    },
    methods: {
        changeSelected(__item, __index) {
            this.selectedIndex = __index;
            this.selectedPage = __item.page;
        },
        upClick() {
            if (this.selectedIndex === 0) {
                return;
            }
            this.selectedIndex--;
            this.selectedPage = this.btnList[this.selectedIndex].page;
            document.documentElement.scrollTop = 520;
        },
        nextClick() {
            if (this.selectedIndex === this.btnList.length - 1) {
                return;
            }
            this.selectedIndex++;
            this.selectedPage = this.btnList[this.selectedIndex].page;
            document.documentElement.scrollTop = 520;
        },
    },
    created() {
        document.documentElement.scrollTop = 0;
        this.selectedIndex = parseInt(this.$route.query.index);
        this.selectedPage = this.btnList[this.selectedIndex].page;
    }
}
</script>

<style lang="scss" scoped>
.box {
    height: 2.9rem;
    width: 100%;
    background: url("../../assets/images/zh.jpg");
    background-size: 100% 100%;
}

.box2 {
    width: 12rem;
    margin: .6rem auto 0;
    display: flex;

    .lef {
        width: 1.9rem;
        overflow: hidden;

        div {
            font-size: .2rem;
            position: relative;
            padding-left: .1rem;
            margin-bottom: .19rem;
        }

        div::before {
            position: absolute;
            content: "";
            left: 0rem;
            top: .06rem;
            background: #E70F20;
            width: 2px;
            height: .16rem;
        }

        p {
            line-height: .34rem;
            font-size: .16rem;
            width: 1.9rem;
            color: #3F3F3F;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;

            a {
                display: inline-block;
                width: 100%;
            }
        }

        .don {
            color: #E70F20
        }
    }

    .rit {
        margin-left: .15rem;
        border-left: 1px solid #E5E5E5;
        padding-left: .85rem;
        width: 9.87rem;

        p.tit {
            width: 5.7rem;
            font-size: .26rem;
            text-align: center;
            margin: 0 auto;
            line-height: .41rem;
            letter-spacing: 1px;
        }

        div.img {
            text-align: center;
            margin-top: .58rem;

            img {
                width: 7rem;
                height: 3.94rem;
            }
        }

        div.txt {
            margin-top: .44rem;
            line-height: .36rem;
            color: #595757;
            font-size: .18rem;
            text-align: justify;
        }

        div.but {
            text-align: center;
            margin-top: .56rem;

            span {
                width: 69px;
                height: 26px;
                line-height: 29px;
                display: inline-block;
                font-size: 12px;
                margin: 0 .25rem;
                cursor: pointer;
            }

            .l {
                background: url("../../assets/images/pg.png");
                background-size: 100% 100%;
                padding-left: .07rem
            }

            .r {
                background: url("../../assets/images/pg2.png");
                background-size: 100% 100%;
                padding-right: .07rem
            }
        }
    }

    .prop {
        width: 10rem;
        font-size: .26rem;
        color: #ddd;
        text-align: center;
        padding-top: 1rem;
    }
}

.content {
    width: 12rem;
    margin: .5rem auto 0;
    display: flex;

    .lef {
        margin-right: .24rem;
        width: 1.9rem;
        overflow: hidden;

        div {
            font-size: .2rem;
            position: relative;
            padding-left: .1rem;
            margin-bottom: .19rem;
        }

        div::before {
            position: absolute;
            content: "";
            left: 0rem;
            top: .06rem;
            background: #E70F20;
            width: 2px;
            height: .16rem;
        }

        p {
            line-height: .34rem;
            font-size: .16rem;
            width: 1.76rem;
            color: #3F3F3F;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;

            a {
                display: inline-block;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .don {
            color: #E70F20
        }
    }

    .right {
        .but {
            text-align: center;
            margin-top: .56rem;

            span {
                width: 69px;
                height: 26px;
                line-height: 29px;
                display: inline-block;
                font-size: 12px;
                margin: 0 .25rem;
                cursor: pointer;
            }

            .l {
                background: url("../../assets/images/pg.png");
                background-size: 100% 100%;
                padding-left: .07rem
            }

            .r {
                background: url("../../assets/images/pg2.png");
                background-size: 100% 100%;
                padding-right: .07rem
            }
        }
    }
}
</style>
